if(!customElements.get('product-wrapper')) {
    customElements.define('product-wrapper', 
        class ProductWrapper extends HTMLElement {
            constructor () {
                super();

                let _this = this;

                this.querySelectorAll('.variant-input').forEach(input => {
                    input.querySelector('.variant__button-label').addEventListener('click', function (e) {
                        const variant_info = JSON.parse(input.querySelector('[data-variant-info]').textContent);
                        
                        _this.querySelector(".product-single__title").innerHTML = variant_info.title
                        _this.querySelector(".product_description .collapsible-content__inner").innerHTML = variant_info.description
                    })
                });
            }
        }
    )
}